<template>
  <div class="first_page section section_bg">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <section v-if="is_load"  class="">



      <div class="container mobile_div  pt-2 pb-2">


        <div class=" mt-2 mb-4  col-12">
          <h2 class="text-center">Награды</h2>
          <p class="text-center">Прогресс:<span class="badge badge-info">{{ percent}} %</span></p>
          <p class="text-center">
            <select class="form-control" @change="changePrivacyRewards" v-model="is_privacy_rewards">
            <option :value="0">скрывать награды</option>
            <option :value="1">показывать в профиле</option>
          </select></p>

        </div>

        <div class="row second_section d-flex justify-content-center mt-2 mb-4  col-12" v-if="rewards.length>0">

          <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container padding_left_right_5   "  v-for="(item,item_index) in rewards" :key="item_index" >
            <div class="item_card_mini">
              <div class="item_data">
                <div class="shop-item-image reward_image">
                  <router-link class="" :to="{name: 'reward_one', params: {id:item.id }}" tag="a" >
                    <v-lazy-image v-if="item.my_award" :src="item.image"  alt="..."/>
                  <svg v-if="!item.my_award" xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                    <path opacity="0.5" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#1C274C"/>
                    <path d="M8.96967 8.96967C9.26256 8.67678 9.73744 8.67678 10.0303 8.96967L12 10.9394L13.9697 8.96969C14.2626 8.6768 14.7374 8.6768 15.0303 8.96969C15.3232 9.26258 15.3232 9.73746 15.0303 10.0304L13.0607 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0304 15.0303C9.73746 15.3232 9.26258 15.3232 8.96969 15.0303C8.6768 14.7374 8.6768 14.2626 8.96969 13.9697L10.9394 12L8.96967 10.0303C8.67678 9.73744 8.67678 9.26256 8.96967 8.96967Z" fill="#1C274C"/>
                  </svg>
                  </router-link>
                </div>


                <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'reward_one', params: {id:item.id }}" tag="a" > {{ item.title}}</router-link></div>
                <div class="shop-item-title d-flex justify-content-center" v-if="!item.my_award"> <p>не открыто</p></div>
                <div class="shop-item-title d-flex justify-content-center" v-if="item.my_award"> <p>{{ item.my_award.created_at}}</p></div>

                <!--            <div class="row text-center">-->

                <!--                <h3>{{ item.count}}</h3>-->

                <!--            </div>-->
                <!--            <div class="row mb-2">-->
                <!--              <div class="col-5">-->
                <!--                <button type="button" @click="changeType(item_index,'-')" class="btn" v-if="count_arr['last_id_'+item.last_id]>0">-</button>-->
                <!--              </div>-->

                <!--              <div class="col-5">-->
                <!--                <button type="button" @click="changeType(item_index,'+')" class="btn">+</button>-->

                <!--              </div>-->
                <!--            </div>-->


              </div>
            </div>

          </div>

        </div>
        <div class="notify_card card col-lg-12 mt-4 section_gray_bg  " v-if="total>offset">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="startLoading()">Загрузить еще</button>

          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "Rewards",
  components: {VLazyImage,LoadingBlock},
  data() {
    return {
      "is_load":false,
      "rewards":[],
      'limit':24,
      'offset':0,
      'total':0,
      'percent':0,
      'is_privacy_rewards':0,
    }
  },
  mounted(){
    var app=this;
    app.startLoading();
  },
  methods:{
    changePrivacyRewards(){
      var app=this;
      Api.rewardsChangePrivacy(app.is_privacy_rewards,function(data){
        console.log('success change privacy rewards!');

      });
    },
    startLoading(){
      var app=this;
      Api.loadRewards(this.limit,this.offset,function(data){
        app.rewards=app.rewards.concat(data.rows);
        app.offset=data.offset;
        app.total=data.total;
        app.percent=data.percent;
        app.is_privacy_rewards=data.is_privacy_rewards;
        app.is_load=true;

      })
    }

  }

}
</script>

<style scoped>

</style>